import { reactive } from 'vue'
import api from '../../api/v2/api'
import Exam from '../models/exam'
import Category from '../models/category'
import { ApiError } from '../../api/v2/api/base/response'
import { SnackBar } from '../models/other_models'
import { snackBarState } from './snackbar'
class ExamMyState {
  isLoading: boolean = false
  list: Exam[] = []
  categories: Category[] = []
  totalCount: number = 0
  category: string = null
  hasAnyExam: boolean = false
  searchingExam: boolean = false

  async getMyExams(startDate = "", endDate = "", categoryId = "") {
    let params = {}
    if(startDate && endDate){
      params = {start_date: startDate, end_date: endDate}
    }
    if(categoryId){
      params = {...params, category_id: categoryId}
    }
    try {
      this.isLoading = true
      const [category, exams, hasAnyExam, totalCount] = await api.exam.my(params)
      this.list = exams
      this.hasAnyExam = hasAnyExam
      this.category = category
      this.totalCount = totalCount
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.isLoading = false
    }
  }

  async getMyCategories() {
    try {
      this.isLoading = true
      this.categories = await api.category.my()
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.isLoading = false
    }
  }

  async searchMyExam(examName = "", startDate = "", endDate = "", type = "") {
    let params: Record<string, string> = {exam_name: examName, type: type}
    if (startDate && endDate) {
      params = {...params, start_date: startDate, end_date: endDate}
    }
    try {
      this.isLoading = true
      this.searchingExam = true
      const [category, exams, hasAnyExam] = await api.exam.my_search(params)
      this.list = exams
      this.hasAnyExam = hasAnyExam
      this.category = category
    } catch (error) {
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
        // Noop
      }
    } finally {
      this.isLoading = false
    }
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const examMyState = reactive(new ExamMyState()) as ExamMyState
